import {VodReviewIcon as Video,TeamMembersIcon as Users,CalendarIcon as CalendarClock,TeamStatsIcon as BarChart3} from '../icons/AppIcons';
import React from 'react';
import {FileText,Target,BookOpen,ListTodo} from 'lucide-react';

export default function OverviewTaskIcon({text='',size=15}) {
  const value=String(text).toLowerCase();
  const Icon=/vod|video|replay|review.*note/.test(value)?Video:/availab|schedule|attendance|confirm.*event/.test(value)?CalendarClock:/roster|lineup|member|join/.test(value)?Users:/prep|document|read/.test(value)?FileText:/stat|metric|analys/.test(value)?BarChart3:/goal|aim|focus|improv/.test(value)?Target:/homework|drill|exercis|assign/.test(value)?BookOpen:ListTodo;
  return <Icon size={size} aria-hidden="true" className="overview-task-icon"/>;
}
